<template>
  <div class="p-3">
    <div class="d-flex">
      <vue-select v-model="choice" :filterable="false" :options="choices" placeholder="Choose an item to share..." class="flex-grow-1 me-2">
        <template v-slot:option="option">
          <font-awesome-icon :icon="option.icon" />
          {{ option.label }}
        </template>
      </vue-select>
      <button :disabled="!choice" class="btn btn-primary btn-sm" @click.prevent="$emit('choice', choice)">Next</button>
    </div>
    <div class="mt-3 text-dark" v-if="choice && choice.objectType == 'artist'">
      Sharing an artist will allow people to hear any mixes uploaded by this artist in the future.
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueSelect from 'vue-select'

export default {
  components: { VueSelect },
  data() {
    this.fetchShareChoiceData()

    return {
      choice: null,
      artists: [],
      mixes: [],
    }
  },
  methods: {
    fetchShareChoiceData() {
      fetch("/artists.json").then(async r => {
        const data = await r.json()
        this.artists = data.map(a => {
          return {
            label: "Artist: " + a.name,
            objectType: 'artist',
            icon: 'user',
            shareURL: "/share/artist/" + a.id + ".json"
          }
        })
      })
      fetch("/mixes.json").then(async r => {
        const data = await r.json()

        data.sort((a, b) => {
          if ( a.name == b.name )
            return a.id < b.id
          else
            return a.name.localeCompare(b.name)
        })

        this.mixes = data.map(m => {
          var label = m.name
          if ( m.version ) {
            if ( m.version.match(/^\d+$/) ) {
              label = label + "#" + m.version
            } else {
              label = label + " - " + m.version
            }
          }

          label += " by " + m.aname

          return {
            icon: 'music',
            objectType: 'mix',
            label: label,
            shareURL: "/share/mix/" + m.id + ".json"
          }
        })
      })
    }
  },
  computed: {
    choices() {
      return this.artists.concat(this.mixes)
    }
  }
}

</script>
